import request from '@/utils/request'

// --------------- 商户产品相关接口 ---------------

// 分页查询商户产品
export function requestMerchantProductPage(data) {
  return request({
    url: '/merProduct/page',
    method: 'post',
    data
  })
}

// 编辑商户产品名称
export function updateMerchantProductName(data) {
  return request({
    url: '/merProduct/updateName',
    method: 'post',
    data
  })
}

// 下载商户产品资源
export function downloadMerchantProductResource(data) {
  return request({
    url: '/merProduct/download',
    method: 'post',
    data
  })
}

// 商品汇出temu
export function exportProductToTemu(data) {
  return request({
    url: '/merProduct/exportTemu',
    method: 'post',
    data
  })
} 

// Excel批量导入修改商品标题
export function importProductTitle(data) {
  return request({
    url: '/merProduct/importTitle',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
} 

// 产品分类
export function requestProductCategory(data) {
  return request({
    url: '/merProduct/category',
    method: 'post',
    data
  })
} 




/**
 * 订单状态同步
 * 
 * @param {*} data 
 * @returns 
 */
export function orderStatus(data) {
  return request({
    url: '/pay-center/order-status',
    method: 'post',
    data
  })
} 

// 积分充值

// 获取积分产品列表
export function requestPointsProductList(data) {
  return request({
    url: '/points/product/list',
    method: 'post',
    data
  })
} 

// 创建积分充值订单并生成支付二维码
export function createPointsOrder(data) {
  return request({
    url: '/points/order/create',
    method: 'post',
    data
  })
} 

// 取消支付
export function cancelPointsOrder(data) {
  return request({
    url: '/points/order/cancel',
    method: 'post',
    data
  })
} 

// 查询支付状态（主动查询）
export function queryPointsOrderStatus(data) {
  return request({
    url: '/points/order/query-status',
    method: 'post',
    data
  })
}
